import { Subject } from "rxjs";

export interface UnlockableWorkspace {
  showUnlockButton: boolean;
  unlock?: Subject<void>;
}

export function isUnlockable(workspace: UnlockableWorkspace): workspace is UnlockableWorkspace {
  return workspace.showUnlockButton !== undefined;
}